import type { RosterRepository } from './Repository.js';
import { DexieRosterRepository } from './DexieRosterRepository.js';

export type { RosterRepository } from './Repository.js';

// The single roster repository instance the app talks to. Swap this binding to
// change the backing store (e.g. native SQLite under Capacitor) — nothing else changes.
export const rosterRepository: RosterRepository = new DexieRosterRepository();
